import { Controller } from '@hotwired/stimulus'

// Active Storage ダイレクトアップロードのプログレスバー表示
export default class extends Controller {
  static targets = ['wrapper', 'progress', 'filename']

  initUpload = (event) => {
    const { file } = event.detail
    this.filenameTarget.textContent = file.name
    this.wrapperTarget.hidden = false
    this.wrapperTarget.classList.add('direct-upload--pending')
  }

  start = () => {
    this.wrapperTarget.classList.remove('direct-upload--pending')
  }

  progress = (event) => {
    const { progress } = event.detail
    this.progressTarget.style.width = `${progress}%`
  }

  error = (event) => {
    event.preventDefault()
    const { error } = event.detail
    this.wrapperTarget.classList.add('direct-upload--error')
    this.wrapperTarget.setAttribute('title', error)
  }

  end = () => {
    this.wrapperTarget.classList.add('direct-upload--complete')
  }
}
